import React from 'react';

// import { Container } from './styles';

function Friend() {
  return <div />;
}

export default Friend;